import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { ESTADOS_EQUIPOS } from 'src/app/administracion/constants/estados-equipos.const';
import { EstadosEquipos } from 'src/app/administracion/enums/estados-equipos.enum';
import { EstadosGestion } from 'src/app/administracion/enums/estados-gestion.enum';
import { TablasDispositivos } from 'src/app/administracion/enums/tablas-dispositivos.enum';
import { Pagina } from 'src/app/administracion/interfaces/pagina.interface';
import { Equipo } from 'src/app/administracion/modelos/Inventario/Equipo/equipo';
import { EquipoService } from 'src/app/administracion/servicios/Inventario/Equipo/equipo.service';
import { ReportesService } from 'src/app/administracion/servicios/reportes/reportes.service';

@Component({
  selector: 'app-reporte-inventario-equipos',
  templateUrl: './reporte-inventario-equipos.component.html',
  styleUrls: ['./reporte-inventario-equipos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReporteInventarioEquiposComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();

  columns = [
    'tipoEquipo',
    'estatus',
    'motivo',
    'etiqueta',
    'marca',
    'modelo',
    'numSerie',
    'colaboradorAsignado',
    // 'fechaAsignacion',
    // 'fechaAlta',
    // 'fechaBaja',
  ];

  cargando = false;
  descargando = false;
  error: string | null = null;
  paginacion = { page: 0, size: 50 };

  equipos: Pagina<Equipo> | null = null;
  filtros: any = {};

  constructor(
    private readonly equipoService: EquipoService,
    private readonly reportesService: ReportesService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  obtenerEquipos() {
    this.cargando = true;
    this.error = null;

    const { tabla, estatus, ...filtros } = this.filtros;

    const tablaSeleccionada = tabla || TablasDispositivos.Computer;

    const estados = estatus?.reduce(
      (acc: any, estado: any) => [
        ...acc,
        ...ESTADOS_EQUIPOS[estado as EstadosGestion],
      ],
      [] as string[],
    );

    this.equipoService
      .obtenerEquipos(tablaSeleccionada, this.paginacion, {
        ...filtros,
        estatus: estados,
      })
      .pipe(
        finalize(() => {
          this.cargando = false;
          this.cdr.markForCheck();
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe({
        next: (equipos) => {
          this.equipos = equipos;
          this.cdr.markForCheck();
        },
        error: () => {
          this.error = 'Ocurrió un error al obtener los equipos';
          this.cdr.markForCheck();
        },
      });
  }

  obtenerReporte() {
    this.descargando = true;
    this.error = null;

    const { tabla, estatus, ...filtros } = this.filtros;
    const tablaSeleccionada = tabla || TablasDispositivos.Computer;

    const estados = estatus?.reduce(
      (acc: any, estado: any) => [
        ...acc,
        ...ESTADOS_EQUIPOS[estado as EstadosGestion],
      ],
      [] as string[],
    );

    this.reportesService
      .obtenerReporteInventarioEquipos(tablaSeleccionada, {
        ...filtros,
        estatus: estados,
      })
      .pipe(
        finalize(() => {
          this.descargando = false;
          this.cdr.markForCheck();
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe({
        next: (file) => {
          this.descargarExcel(file);
          this.cdr.markForCheck();
        },
        error: () => {
          this.error = 'Ocurrió un error al obtener el reporte';
          this.cdr.markForCheck();
        },
      });
  }

  onPageEvent(event: PageEvent) {
    this.paginacion.page = event.pageIndex;
    this.paginacion.size = event.pageSize;
    this.obtenerEquipos();
  }

  private descargarExcel(file: Blob) {
    const fecha = new Date().toISOString().split('T')[0];
    const url = URL.createObjectURL(file);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `inventario-equipos-${fecha}.xlsx`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  }

  obtenerEstatus(motivo: EstadosEquipos) {
    const estado = Object.entries(ESTADOS_EQUIPOS)
      .filter(([_, estados]) => estados.includes(motivo))
      .map(([estado]) => estado);

    //remover pluralidad
    return estado.length > 0 ? estado[0].replace(/s$/, '') : null;
  }
}
